module.exports = __webpack_public_path__ + "static/media/student-hw-evaluated.0a31d658.svg";